import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const LearnMorePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white flex flex-col items-center justify-center p-8 relative overflow-hidden">
      <div className="absolute top-[-100px] left-[-100px] w-96 h-96 bg-blue-500 opacity-25 blur-3xl rounded-full"></div>
      <div className="absolute bottom-[-100px] right-[-100px] w-96 h-96 bg-purple-500 opacity-25 blur-3xl rounded-full"></div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="max-w-3xl text-center space-y-6 bg-gray-900/50 backdrop-blur-lg p-10 rounded-xl shadow-lg"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-400 to-purple-400 text-transparent bg-clip-text">
          Simplify Your Task Management with TaskVerse
        </h2>
        <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
          <span className="font-bold text-white">TaskVerse</span> is designed to make your daily workflow more structured and stress-free.  
          With an intuitive interface, <span className="font-bold text-blue-300">customizable task lists</span>, and an easy-to-use dashboard, you can <span className="font-bold text-purple-300">plan, prioritize, and track your progress effortlessly</span>.  
          Whether you're an individual or part of a team, TaskVerse ensures you stay on top of your tasks <span className="font-bold text-blue-400">without distractions</span>.
        </p>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate(-1)}
          className="mt-6 bg-purple-600 hover:bg-purple-700 transition-all text-white font-bold py-3 px-8 rounded-full shadow-lg text-lg"
        >
          Go Back
        </motion.button>
      </motion.div>
    </div>
  );
};

export default LearnMorePage;
